import React from 'react';
import { Link } from 'react-router-dom';
import { FiLogOut , FiUser } from "react-icons/fi";

import logo from '../../../assets/images/logo.svg'

import './nav.scss';

export default function Nav({ activePage , logout }) {

  return (
    <nav className={`${activePage === "login" ? "" : "isActive"}`}>
      <div className="content">

        <Link to="/dashboard">
          <div className="logo">
            <img src={logo} alt=""/>
          </div>
        </Link>

        <div className="links">
          <Link to="/dashboard" className={`${activePage === "dashboard" ? "isActive" : ""}`}>DASHBOARD</Link>
          <Link to="/study" className={`${activePage === "studies" || activePage === "study" ? "isActive" : ""}`}>LISTE DES ÉTUDES</Link>
          <Link to="/status" className={`${activePage === "status" ? "isActive" : ""}`}>SUIVI DE STATUT</Link>
          <Link to="/centers" className={`${activePage === "centers" ? "isActive" : ""}`}>CENTRES</Link>
        </div>
        
        <div className="icons">

          <Link to="/account">
            <FiUser size={22} color={"#192243"}/>
          </Link>

          <button className="logout" onClick={() => logout()}>
            <FiLogOut size={22} color={"#192243"}/>
          </button>

        </div>

      </div>

    </nav>
  )
}
